import { useTranslation } from 'react-i18next';
import useUser from 'src/hook/data/useUser';
import { GetRazorSiteUrl, IconLocation } from '../../../../utils/URLUtils';
import styles from './VideoSection.module.scss';

interface VideoSectionProps {
    handleOpenModal: (url: string, title?: string) => void;
}

const VideoSection = ({ handleOpenModal }: VideoSectionProps) => {
    const { t, i18n } = useTranslation();
    const { userInfo } = useUser();

    return (
        <div className={styles.section}
            onClick={() => handleOpenModal(
                GetRazorSiteUrl('profile/video-guides', userInfo?.Token),
                t('Learn how to use WordUp')
            )}>
            <div className={styles.video}>
                <img src={IconLocation('play-circle')} alt={t('Video')} />
                <span dir={i18n.dir()} >{t('Learn how to use WordUp')}</span>
            </div>
        </div>
    );
};

export default VideoSection;